/**
 * A context of an authentication.
 */
var ContextualInfo = /** @class */ (function () {
    function ContextualInfo() {
    }
    return ContextualInfo;
}());
export { ContextualInfo };
/** Enumerates step-up triggers. */
export var TriggerName;
(function (TriggerName) {
    TriggerName["Behavior"] = "behavior";
    TriggerName["IP"] = "ip";
    TriggerName["Device"] = "device";
    TriggerName["AltusInstalled"] = "altusInstalled";
    TriggerName["Computer"] = "computer";
    TriggerName["Domain"] = "domain";
    TriggerName["User"] = "user";
    TriggerName["InsideFirewall"] = "insideFirewall";
    TriggerName["RemoteSession"] = "remoteSession";
})(TriggerName || (TriggerName = {}));
//# sourceMappingURL=stepUp.js.map